import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchOrders, silentFetchOrders, setOrdersPaging, deleteOrder, setOrdersFilters, handleConsumption } from '../../action/orders';
import { fetchCities, fetchFilials, fetchPayments, fetchSources, fetchZonesByCities } from '../../action/handbook';
import Loader from '../utils/Loader';
import Portlet from '../utils/Portlet';
import ReactPaginate from 'react-paginate';
import OrdersTable from './OrdersTable';
import swal from 'sweetalert';
import ErrorContainer from '../utils/ErrorContainer';
import Select from 'react-select';
import DateInput from '../utils/DateInput';
import moment from 'moment';
import '../../styles/order_table.css'
import { fetchSettings } from '../../action/app';
import { defaultPlatforms, optionsStatus, roleId, urls } from '../../constants/app';
import { setUIvisible } from '../../action/UImobile';
import { setActiveModalAction } from '../../action';
import request from '../../action/utils/request';
import { getStatusKKT } from '../../action/cassa';
import { initializeNotifications, disconnectNotifications, updateNotificationPreferences } from '../../action/notifications';
import PointsSelect from '../utils/PointsSelect';
import MultiSelect from '../utils/MultiSelect';
import { isEmpty } from 'lodash';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

const getDateValue = (type) => {
    const date = new Date()
    switch(type){
        case 'tomorrow':{
            return {Min: moment(date).add(1,'days').format('YYYY-MM-DD 00:00:00'), Max: moment(date).add(1,'days').format('YYYY-MM-DD 23:59:59')};
        }
        case 'yesterday':{
            return {Min: moment(date).subtract(1,'days').format('YYYY-MM-DD 00:00:00'), Max: moment(date).subtract(1,'days').format('YYYY-MM-DD 23:59:59')};
        }
        case 'week':{
            let monday = moment(date);
            monday.startOf('isoWeek'); 

            let sunday = moment(date);
            sunday.endOf('isoWeek'); 

            return {Min: monday.format('YYYY-MM-DD 00:00:00'), Max: sunday.format('YYYY-MM-DD 23:59:59')};
        }
        case 'month':{
            return {Min: moment(date).startOf('month').format('YYYY-MM-DD 00:00:00'), Max: moment(date).endOf('month').format('YYYY-MM-DD 23:59:59')};
        }
        default: {
            return {Min: moment(date).format('YYYY-MM-DD 00:00:00'), Max: moment(date).format('YYYY-MM-DD 23:59:59')};
        }
    }
}

const payments = [
    {label: 'Все виды', value: null},
    {label: 'Без оплаты', value: 'none'},
    {label: 'Наличные', value: 'cash'},
    {label: 'Терминал', value: 'terminal'},
    {label: 'ЮКасса', value: 'online'},
    {label: 'Яндекс', value: 'YE'},
    {label: 'Деливери', value: 'DC'},
];

class OrdersList extends Component {
    state = {
        currentPage: 0,
        selectedDate: null,
        openDateInput: false,
        dateValue: [
            {label: `Завтра ${moment(getDateValue('tomorrow').Min).format('DD.MM.YYYY')}`, value: getDateValue('tomorrow')},
            {label: `Сегодня ${moment(getDateValue('today').Min).format('DD.MM.YYYY')}`, value: getDateValue('today')},
            {label: `Вчера ${moment(getDateValue('yesterday').Min).format('DD.MM.YYYY')}`, value: getDateValue('yesterday')},
            {label: 'Текущая неделя', value: getDateValue('week')},
            {label: 'Текущий месяц', value: getDateValue('month')},
            {label: 'Период', value: 'period'}
        ],
        getCouriers: false,
        kktStatus: null,
        kktLoading: false,
        platforms: defaultPlatforms,
    }

    DateInputRef = React.createRef();

    handleBeforeUnload = (event) => {
        if (this.props.blockFiscal) {
          event.preventDefault();
          event.returnValue = 'Идёт фискализация. Вы уверены, что хотите покинуть страницу?';
          return event.returnValue;
        }
    };

    getBlockMessage = (location, action) => {
        if (this.props.blockFiscal) return 'Идёт фискализация. Вы уверены, что хотите покинуть страницу?';
        return null;
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.filters !== prevState.filters) {
            const dateValue = [
                {label: `Завтра ${moment(getDateValue('tomorrow').Min).format('DD.MM.YYYY')}`, value: getDateValue('tomorrow')},
                {label: `Сегодня ${moment(getDateValue('today').Min).format('DD.MM.YYYY')}`, value: getDateValue('today')},
                {label: `Вчера ${moment(getDateValue('yesterday').Min).format('DD.MM.YYYY')}`, value: getDateValue('yesterday')},
                {label: 'Текущая неделя', value: getDateValue('week')},
                {label: 'Текущий месяц', value: getDateValue('month')},
                {label: `Период ${(prevState.selectedDate && prevState.selectedDate.value === 'period') ? moment(nextProps.filters.createdStartDate).format('DD.MM.YYYY') + ' - ' : ''}${(prevState.selectedDate && prevState.selectedDate.value === 'period') ? moment(nextProps.filters.createdEndDate).format('DD.MM.YYYY') : ''}`, value: 'period'}
            ];
            if(prevState.selectedDate && prevState.selectedDate.value === 'period') {
                return { dateValue, selectedDate: {
                    label: `Период ${moment(nextProps.filters.createdStartDate).format('DD.MM.YYYY')} - ${moment(nextProps.filters.createdEndDate).format('DD.MM.YYYY')}`,
                    value: 'period'
                } };
            }
            return { dateValue };
        }
        return null;
    }

    handleClickOutside = (event) => {
        if (this.DateInputRef.current && !this.DateInputRef.current.contains(event.target)) {
          this.setState({ openDateInput: false });
        }
      };

    componentDidMount() {
        if ([roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role)) this.setState({ getCouriers: true });

        const getSources = async () => {
            if (isEmpty(this.props.sources)) {
                const entitySources = await this.props.fetchSources(true, true, true);
                this.setState({ platforms: entitySources.map((item) => ({ label: item.name, value: item.value }))});
            } else {
                this.setState({ platforms: this.props.sources.map((item) => ({ label: item.name, value: item.value }))});
            }
        }

        const getData = async () => {
            await Promise.all([
                this.onChangeDateSelect(this.state.dateValue[1]),
                this.props.fetchOrders(this.props.isArchive, [roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role)),
                this.props.fetchCities(),
                this.props.fetchFilials(null),
                this.props.fetchSettings(),
                this.props.fetchPayments(true),
                this.getKKTStatus(),
                getSources(),
            ]);

            this.props.payments.forEach((payment) => {
                const isDuplicate = payments.some(item => item.value === payment.Name);
                if (!isDuplicate) {
                    payments.push({ label: payment.VisibleName, value: payment.Name });
                }
            });

            this.props.fetchZonesByCities();
            //document.addEventListener('mousedown', this.handleClickOutside); handleClickOutside срабатывает при клике на календарь DateInput и закрывает окно с выбором периода
        }

        getData();
        this.props.setUIvisible(true, false);
        if (!this.props.isArchive) {
            if (this.props.sseEnabled) {
                this.props.initializeNotifications();
            }
            this.startAutoRefresh();
        }

        this.unblock = this.props.history.block(this.getBlockMessage);
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.filters.points !== this.props.filters.points || prevProps.userPoints !== this.props.userPoints) await this.getKKTStatus();
        if (prevProps.sseEnabled !== this.props.sseEnabled) {
            if (this.props.sseEnabled) {
                this.props.initializeNotifications();
            } else {
                this.props.disconnectNotifications();
            }
        }
        if (prevProps.autoRefreshEnabled !== this.props.autoRefreshEnabled ||
            prevProps.autoRefreshInterval !== this.props.autoRefreshInterval) {
            this.startAutoRefresh();
        }
    }

    componentWillUnmount() {
        const { paging, filters } = this.props;
        this.props.setOrdersPaging({ ...paging, start: 0 });
        const updated = { ...filters }

        updated.city = null;

        this.props.setOrdersFilters(updated);
        this.props.disconnectNotifications();
        this.stopAutoRefresh();

        if (this.unblock) {
            this.unblock();
            this.unblock = null;
        }
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    setPageLimit = (e) => {
        e.preventDefault();
        if (this.props.role === roleId.admin) localStorage.setItem('ordersPageLimit', e.target.value);
        const updatedPaging = { start: 0, limit: e.target.value, localLimit: e.target.value };
        this.setState({ currentPage: 0 });
        this.props.setOrdersPaging(updatedPaging);
        this.props.fetchOrders(this.props.isArchive, this.state.getCouriers);
    }

    handlePageClick = data => {
        const { paging } = this.props;
        const limit = (this.props.role === roleId.admin && paging.localLimit) ? paging.localLimit : paging.limit;
        this.setState({ currentPage: data.selected }, () => {
            let nextStart =  data.selected * limit;
            const updatedPaging = {...paging, start: nextStart};
            this.props.setOrdersPaging(updatedPaging);
            this.props.fetchOrders(this.props.isArchive, this.state.getCouriers);
        });
    };

    chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 400) return 1;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        if(userDisplayWidth < 1250) return 5;
        return 8;
    }

    chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    renderPagination() {
        const { count, paging } = this.props;
        const limit = (this.props.role === roleId.admin && paging.localLimit) ? paging.localLimit || paging.limit : paging.limit;
        const pages = Math.ceil(+count / +limit);
        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={this.chekMarginPagesDisplayed()}
                    pageRangeDisplayed={this.chekPageRangeDisplayed()}
                    forcePage={this.state.currentPage}
                    onPageChange={this.handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={this.setPageLimit} value={limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    setOrdersFilters = (field, notSearch = false) => (data) => {
        const { filters } = this.props;
        
        let updated = {
            ...filters,
            [field]: data
        }

        if (data === null || data.value === null) {
            updated = {
                ...filters,
                [field]: null
            }
        }

        this.props.setOrdersFilters(updated);
        if (!notSearch) this.onSearch()
    }

    onChangeInput = (field) => (e) => {
        const value = e.target.value;

        const { filters } = this.props;
        const updated = {
            ...filters,
            [field]: value
        }
        this.props.setOrdersFilters(updated);
    }

    onChangeDateSelect = (e) => {
        const { filters } = this.props;

        const updated = {
            ...filters
        };

        if(e.value !== 'period') {
            updated.createdStartDate = moment(e.value.Min).toDate();
            updated.createdEndDate = moment(e.value.Max).toDate();        
            this.props.setOrdersFilters(updated);
            this.onSearch();    
            this.setState({ selectedDate: e });
        } else {
            this.setState({ openDateInput: true });
        }
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props;

        const updated = {
            ...filters,
            [field]: date,
        };

        if (field === 'createdStartDate') updated.createdEndDate = moment(date).add({ days: 30 }).endOf('day').toDate()
        
        this.props.setOrdersFilters(updated);
    }

    onSearch = () => {
        if (this.props.blockFiscal) return;

        const { paging } = this.props;
        this.props.setOrdersPaging({ ...paging, start: 0 });
        this.setState({ currentPage: 0, openDateInput: false });
        this.props.fetchOrders(this.props.isArchive, this.state.getCouriers);
    }

    resetFilter = () => {
        this.props.setOrdersFilters({ city: null, point: null, status: null, createdEndDate: null, createdStartDate: null, phone: null, id: null });
        this.setState({ currentPage: 0 });
        this.props.fetchOrders(this.props.isArchive, this.state.getCouriers);
    }

    clearSearchFilter = () => {
        const { filters } = this.props;
        this.props.setOrdersFilters({ ...filters, phone: null, id: null });
        this.props.setOrdersPaging({ ...this.props.paging, start: 0 });
        this.setState({ currentPage: 0 });
        this.props.fetchOrders(this.props.isArchive, this.state.getCouriers);
    }

    renderAdress(item) {
        return `${item.city.name}, ${item.street}, ${item.house}${item.entrance ? `, подъезд ${item.entrance}` : ''}${item.room ? `, кв./оф. ${item.room}` : ''}`;
    }

    async getKKTStatus() {
        if (![roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role)) return this.setState({ kktStatus: null});
        
        let pointId = null;
        if (!this.props.userPoints || this.props.userPoints.length !== 1) {
            if (!this.props.filters.points || this.props.filters.points.length === 0 || this.props.filters.points.length > 1) return this.setState({ kktStatus: null});
            pointId = this.props.filters.points[0].value;
        } else {
            pointId = this.props.userPoints[0].id;
        }
        
        if (!pointId) return this.setState({ kktStatus: null });;
        
        this.setState({ kktLoading: true });
        try {
            const result = await this.props.getStatusKKT(pointId);
            this.setState({ kktStatus: result, kktLoading: false });
        } catch (error) {
            this.setState({ kktLoading: false });
        }
    }

    renderFRStatus() {
        const { kktStatus, kktLoading } = this.state;
        if (![roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role)) return null;
        let btn = 'btn-danger';
        if (kktStatus && !kktStatus.error) btn = 'btn-success';
        if (kktLoading || kktStatus) return <button onClick={(async () => !kktLoading && await this.getKKTStatus())} className={`btn btn-icon ${btn}`}> ФР </button>
        return null;
    }

    handleConsumption = async () => {
        const result = await this.props.handleConsumption(this.props.isArchive);
        if (result && result.error) return swal({
            title: "Ошибка",
            text: result.error.message || '',
            icon: "error",
            button: "Ок",
        }).then(() => this.onRefresh());
        return this.onRefresh()
    }

    renderSubHeader() {
        const { isArchive } = this.props;

        return (
                                     
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid" style={{ display: 'flex', justifyContent: 'space-between'}}>
                    <div className="kt-subheader__main">
                        {[roleId.admin, roleId.cashier, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.marketingSpecialist, roleId.chiefMarketingSpecialist, roleId.chiefCommoditySpecialist].includes(this.props.role) ? 
                        <>
                            <h3 className="kt-subheader__title" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem', padding: '0px', paddingRight: '5px'} : {}}>{isArchive ? 'Архив заказов' : 'Заказы'}</h3>
                            <div className="kt-subheader__group" id="kt_subheader_search" style={window.innerWidth <= 1024 ? {display: 'block'} : {}}>
                                <span className="kt-subheader__desc" id="kt_subheader_total" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem'} : {}}>
                                    {(this.props.statistics && this.props.statistics.result) ? this.props.statistics.result.count || 0 : 0}
                                </span>
                            </div>
                            <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                            <h3 className="kt-subheader__title" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem', padding: '0px', paddingRight: '5px'} : {}}> Средний чек </h3>
                            <div className="kt-subheader__group" id="kt_subheader_search" style={window.innerWidth <= 1024 ? {display: 'block'} : {}}>
                                <span className="kt-subheader__desc" id="kt_subheader_total" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem'} : {}}>
                                    {(this.props.statistics && this.props.statistics.result && this.props.statistics.result.count > 0) ? parseFloat(this.props.statistics.result.sum / this.props.statistics.result.count).toFixed(2) : 'Ошибка'}
                                </span>
                            </div>
                            
                            <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                            <h3 className="kt-subheader__title" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem', padding: '0px', paddingRight: '5px'} : {}}> Выручка </h3>
                            <div className="kt-subheader__group" id="kt_subheader_search" style={window.innerWidth <= 1024 ? {display: 'block'} : {}}>
                                <span className="kt-subheader__desc" id="kt_subheader_total" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem'} : {}}>
                                    {(this.props.statistics && this.props.statistics.result) ? this.props.statistics.result.sum || 0 : 'Ошибка'}
                                </span> 
                            </div>          
                        </>
                        :
                        <>
                            <h3 className="kt-subheader__title" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem', padding: '0px', paddingRight: '5px'} : {}}>{isArchive ? 'Архив заказов' : 'Заказы'}</h3>
                            <div className="kt-subheader__group" id="kt_subheader_search" style={window.innerWidth <= 1024 ? {display: 'block'} : {}}>
                                <span className="kt-subheader__desc" id="kt_subheader_total" style={window.innerWidth <= 1024 ? {fontSize: '0.8rem'} : {}}>
                                    {this.props.count || 0}
                                </span>
                            </div>
                        </>
                        }
                        {window.innerWidth < 1024 && this.renderFRStatus()}
                    </div>
                    {window.innerWidth > 1024 && 
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        {this.props.role === roleId.admin &&
                            <button onClick={this.handleConsumption} className='btn btn-secondary'>Ручной расчет сырья</button>
                        }
                        {this.renderFRStatus()}
                        <button disabled={this.props.blockFiscal} onClick={this.onOpenModalSearch} className='btn btn-secondary btn-icon'><i className="la la-search"></i></button>
                        {(this.props.filters.phone || this.props.filters.id) && <button
                            onClick={this.clearSearchFilter}
                            className='btn btn-warning btn-icon'
                            disabled={this.props.blockFiscal}
                            title={this.props.filters.phone ? `Поиск по тел: ${this.props.filters.phone}` : `Поиск по заказу: ${this.props.filters.id}`}
                        ><i className="la la-times"></i></button>}
                        <button disabled={this.props.blockFiscal} onClick={this.onRefresh} className='btn btn-secondary btn-icon'><i className="la la-refresh"></i></button>
                    </div>
                    } 
                </div>                
            </div>
        );
    }

    onDelete = async (item) => {
        if (item.fiscalized) return swal({
            title: "Заказ фискализирован",
            text: "Удаление заказа невозможно",
            icon: "warning",
            button: "Ок",
        });

        if(item.isConsumption) {
            return swal({
                title: "Товары из заказа учтены.",
                text: 'Удаление заказа невозможно. Чтобы удалить заказ - измените его статус на "Приготовлен".',
                icon: "warning",
                button: "Ок",
            });
        }

        if(item.workingShiftId) {
            const workingShift = await request({ method: 'get', url: `${urls.workingShift}/${item.workingShiftId}` });
            if((workingShift && workingShift.closed_at) || (item.workingshift && item.workingshift.closed_at)) {
                return swal({
                    title: "Смена закрыта",
                    text: "Удаление заказа невозможно",
                    icon: "warning",
                    button: "Ок",
                });
            }
        }

        swal({
            title: "Удаление заказа",
            text: `Вы действительно хотите удалить заказ №${item.id}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                this.props.deleteOrder(item.id, this.props.isArchive).then(result => {
                    if (result) {
                        this.props.fetchOrders(this.props.isArchive, this.state.getCouriers);
                    }
                })
            }
        });
    }

    startAutoRefresh = () => {
        this.stopAutoRefresh();
        if (this.props.autoRefreshEnabled && !this.props.isArchive) {
            const intervalMs = (this.props.autoRefreshInterval || 30) * 1000;
            this.autoRefreshTimer = setInterval(() => {
                this.props.silentFetchOrders(this.props.isArchive, this.state.getCouriers);
                this.getKKTStatus();
            }, intervalMs);
        }
    }

    stopAutoRefresh = () => {
        if (this.autoRefreshTimer) {
            clearInterval(this.autoRefreshTimer);
            this.autoRefreshTimer = null;
        }
    }

    onRefresh = () => {
        if (this.props.blockFiscal) return;
        const { paging } = this.props;
        this.props.setOrdersPaging({ ...paging, start: 0 });
        this.setState({ currentPage: 0, openDateInput: false });
        this.props.fetchOrders(this.props.isArchive, this.state.getCouriers);
        this.props.fetchFilials(null);
        if(!this.props.settings) this.props.fetchSettings();
    }

    onOpenModalSearch = () => {
        if (this.props.blockFiscal) return;
        this.props.setActiveModalAction({ field: 'orderSearch', value: true });
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.onSearch(); 
        }
    }

    renderCourierLabel = (courier) => {
        if (!courier) return null;
        return courier.name || courier.username || 'Имя не определено';
    };

    getCouriersValues = () => {
        if (!this.props.couriers || this.props.couriers.length === 0) return [{ value: 'all', label: 'Все сотрудники' }, { value: 'none', label: 'Без сотрудника' }];
        return [ { value: 'all', label: 'Все сотрудники' }, { value: 'none', label: 'Без сотрудника' } , ...this.props.couriers.map((courier) => ({ value: courier.id, label: this.renderCourierLabel(courier)}))];
    }

    renderFiltersBlock(){
        const couriersValues = this.getCouriersValues();
        if(window.innerWidth <= 900 && this.props.UImobile.openFilters)
            return(
            <>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginTop: '10px', gap: '10px'}} onKeyDown={this.onKeyDown}>
                            <div style={{ width: 250 }}>
                                <Select
                                    isLoading={this.props.loading}
                                    isDisabled={this.props.loading || this.props.blockFiscal}
                                    placeholder='Дата'
                                    value={this.state.selectedDate}
                                    onChange={(e) => this.onChangeDateSelect(e)}
                                    options={this.state.dateValue}
                                />
                                {this.state.openDateInput && <div style={{ position: 'relative' }}>
                                    <div ref={this.DateInputRef} style={{ position: 'absolute', zIndex: '1', backgroundColor: '#fff', borderRadius: '4px', padding: '10px', color: '#000', marginTop: '10px' }}>
                                        <div>Период с</div>
                                        <DateInput
                                            disabled={this.props.blockFiscal}
                                            placeholderText="Дата от"
                                            selected={this.props.filters.createdStartDate}
                                            onChange={this.onChangeDateInput('createdStartDate')}
                                        />
                                        <div>по</div>
                                        <DateInput
                                            disabled={this.props.blockFiscal}
                                            placeholderText="Дата до"
                                            selected={this.props.filters.createdEndDate}
                                            onChange={this.onChangeDateInput('createdEndDate')}
                                            maxDate={moment(this.props.filters.createdStartDate).add({ days: 30 }).toDate()}
                                            required={this.props.filters.createdStartDate}
                                        />
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px'}}>
                                            <button
                                            className='btn btn-secondary'
                                            onClick={(() => {
                                                this.setState({ openDateInput: false });
                                            })}
                                            >
                                                Закрыть
                                            </button>
                                            <button
                                            disabled={this.props.blockFiscal}
                                            className='btn btn-primary'
                                            onClick={(() => {
                                                this.setState({ selectedDate: this.state.dateValue[this.state.dateValue.length - 1] });
                                                this.onSearch();
                                            })}
                                            >
                                                Найти
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            <div style={{ width: 200 }}>
                                <Select
                                placeholder='Оплата'
                                isLoading={this.props.loading}
                                isDisabled={this.props.loading || this.props.blockFiscal}
                                value={this.props.filters.payment}
                                onChange={this.setOrdersFilters('payment', true)}
                                options={payments}                        
                                />
                            </div>       
                            <div style={{ width: 200 }}>
                                <Select
                                placeholder='Сырье'
                                isLoading={this.props.loading}
                                isDisabled={this.props.loading || this.props.blockFiscal}
                                value={this.props.filters.consumption}
                                onChange={this.setOrdersFilters('consumption')}
                                options={[
                                    { label: 'Все виды', value: null },
                                    { label: 'Списано', value: 'consumption'},
                                    { label: 'Не списано', value: 'notConsumption'},
                                    { label: 'Расчет', value: 'processing' },
                                    { label: 'Ошибка', value: 'error' },
                                ]}                        
                                />
                            </div>                   
                            <div style={{ width: 250 }}>
                                <PointsSelect width={200}
                                    placeholder='Филиалы' 
                                    values={this.props.filters.points} 
                                    setData={this.setOrdersFilters('points', true)} 
                                    disabled={this.props.loading || this.props.filters.zone || (this.props.filters.cities && this.props.filters.cities.length > 0) || this.props.blockFiscal}
                                    notAll={true}
                                />
                            </div>

                            <div style={{ width: 200 }}>
                                <MultiSelect
                                    data={this.props.cities.map((city) => ({ label: city.name, value: city.id }))}
                                    placeholder='Город'
                                    loading={this.props.loading}
                                    disabled={this.props.loading || (this.props.filters.points && this.props.filters.points.length > 0) || this.props.blockFiscal}
                                    setData={this.setOrdersFilters('cities', true)}
                                    values={this.props.filters.cities} 
                                    notAll={true}
                                />
                            </div>

                            <div style={{ width: 250 }}>
                                <MultiSelect
                                    data={optionsStatus}
                                    placeholder='Статус'
                                    loading={this.props.loading}
                                    disabled={this.props.loading || this.props.blockFiscal}
                                    setData={this.setOrdersFilters('statuses', true)}
                                    values={this.props.filters.statuses}
                                    notAll={true}
                                />
                            </div>    
                            {[roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role) && <div style={{ width: 200 }}>
                            <Select
                                isLoading={this.props.loading || this.props.loadingCourier}
                                isDisabled={this.props.loading || this.props.loadingCourier || !this.props.couriers || this.props.blockFiscal}
                                placeholder='Курьер'
                                value={this.props.filters.courier}
                                onChange={this.setOrdersFilters('courier', true)}
                                options={couriersValues}
                                isClearable={true}
                                noOptionsMessage={() => 'Курьеры не найдены'}
                            />
                            </div>}
                            <div style={{ width: 250 }}>
                                <Select
                                    isLoading={this.props.loading}
                                    isDisabled={this.props.loading || this.props.blockFiscal}
                                    placeholder='Источник'
                                    value={this.props.filters.source}
                                    onChange={this.setOrdersFilters('source')}
                                    isClearable={true}
                                    options={[
                                        { label: 'Без источника', value: 'none' },
                                        ...this.state.platforms,
                                    ]}
                                />
                            </div>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <button disabled={this.props.blockFiscal} className='btn btn-primary' onClick={this.onSearch}>Найти</button>
                </div>
            </>
        );

        if(window.innerWidth > 1024 || this.props.UImobile.openFilters)
            return(
                <table className="kt-datatable__table" onKeyDown={this.onKeyDown} style={{ backgroundColor: '#00000000', width: '100%' }}>
                    <tr className='kt-datatable__row'>
                        <td className='kt-indicator' style={{ backgroundColor: '#00000000' }}></td>
                        <td className='kt-datatable__cell order_table positions'>
                            <Select
                                isLoading={this.props.loading}
                                isDisabled={this.props.loading || this.props.blockFiscal}
                                placeholder='Дата'
                                value={this.state.selectedDate}
                                onChange={(e) => this.onChangeDateSelect(e)}
                                options={this.state.dateValue}
                            />
                            {this.state.openDateInput && <div style={{ position: 'relative' }}>
                                <div ref={this.DateInputRef} style={{ position: 'absolute', zIndex: '1', backgroundColor: '#fff', borderRadius: '4px', padding: '10px', color: '#000', marginTop: '10px' }}>
                                    <div>Период с</div>
                                    <DateInput
                                        disabled={this.props.blockFiscal}                                                             
                                        placeholderText="Дата от"
                                        selected={this.props.filters.createdStartDate}
                                        onChange={this.onChangeDateInput('createdStartDate')}
                                    />
                                    <div>по</div>
                                    <DateInput
                                        disabled={this.props.blockFiscal}
                                        placeholderText="Дата до"
                                        selected={this.props.filters.createdEndDate}
                                        onChange={this.onChangeDateInput('createdEndDate')}
                                        maxDate={moment(this.props.filters.createdStartDate).add({ days: 30 }).toDate()}
                                        required={this.props.filters.createdStartDate}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px'}}>
                                        <button
                                        className='btn btn-secondary'
                                        onClick={(() => {
                                            this.setState({ openDateInput: false });
                                        })}
                                        >
                                            Закрыть
                                        </button>
                                        <button 
                                        className='btn btn-primary'
                                        disabled={this.props.blockFiscal}
                                        onClick={(() => {
                                            this.setState({ selectedDate: this.state.dateValue[this.state.dateValue.length - 1] });
                                            this.onSearch();
                                        })}
                                        >
                                            Найти
                                        </button>
                                    </div>
                                </div>
                            </div>}
                        </td>
                        <td className='kt-datatable__cell order_table total_price' style={{ position: 'relative' }}>
                            <div className='order_table consumption select'>
                                <Select
                                placeholder='Сырье'
                                isLoading={this.props.loading}
                                isDisabled={this.props.loading || this.props.blockFiscal}
                                value={this.props.filters.consumption}
                                onChange={this.setOrdersFilters('consumption')}
                                options={[
                                    { label: 'Все виды', value: null },
                                    { label: 'Списано', value: 'consumption'},
                                    { label: 'Не списано', value: 'notConsumption'},
                                    { label: 'Расчет', value: 'processing' },
                                    { label: 'Ошибка', value: 'error' },
                                ]}                        
                                />
                            </div>  
                        </td>
                        <td className='kt-datatable__cell order_table total_price'></td>
                        <td className='kt-datatable__cell order_table payment' style={{ position: 'relative' }}>
                            <div className='order_table payment select'>
                                <Select
                                placeholder='Оплата'
                                isLoading={this.props.loading}
                                isDisabled={this.props.loading || this.props.blockFiscal}
                                value={this.props.filters.payment}
                                onChange={this.setOrdersFilters('payment')}
                                options={payments}                        
                                />
                            </div>                        
                        </td>
                        <td className='kt-datatable__cell order_table point_time'></td>
                        <td className={`kt-datatable__cell order_table select_point${(window.innerWidth > 1024 && this.state.openClient) ? ' openClient' : ''}`}>
                            <div style={{ width: '100%', height: '100%', marginTop: '1px' }}>
                                <PointsSelect width={200}
                                    placeholder='Филиалы'
                                    blur={true}
                                    values={this.props.filters.points} 
                                    setData={this.setOrdersFilters('points')} 
                                    disabled={this.props.loading || this.props.filters.zone || (this.props.filters.cities && this.props.filters.cities.length > 0) || this.props.blockFiscal}
                                    notAll={true}
                                />
                            </div>
                        </td>                           
                        <td className='kt-datatable__cell order_table comment'>
                            <div style={{ display: 'flex', gap: '10px', marginTop: '1px' }}>
                                <MultiSelect
                                    blur={true}
                                    data={this.props.cities.map((city) => ({ label: city.name, value: city.id }))}
                                    placeholder='Город'
                                    width={'50%'}
                                    loading={this.props.loading}
                                    disabled={this.props.loading || (this.props.filters.points && this.props.filters.points.length > 0) || this.props.blockFiscal}
                                    setData={this.setOrdersFilters('cities')}
                                    values={this.props.filters.cities} 
                                    notAll={true}
                                />
                                {[roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(this.props.role) && <div style={{ width: '50%' }}>
                                    <Select
                                        isLoading={this.props.loading || this.props.loadingCourier}
                                        isDisabled={this.props.loading || this.props.loadingCourier || !this.props.couriers || this.props.blockFiscal}
                                        placeholder='Курьер'
                                        value={this.props.filters.courier}
                                        onChange={this.setOrdersFilters('courier')}
                                        options={couriersValues}
                                        isClearable={true}
                                        noOptionsMessage={() => 'Курьеры не найдены'}
                                    />
                                </div>}
                            </div>
                            
                        </td>
                        <td onDoubleClick={((event) => {event.stopPropagation()})} className='kt-datatable__cell order_table phone'>
                            <div style={{ width: '100%', height: '100%', marginTop: '1px' }}>
                                <MultiSelect
                                    blur={true}
                                    data={optionsStatus}
                                    placeholder='Статус'
                                    width={'auto'}
                                    loading={this.props.loading}
                                    disabled={this.props.loading || this.props.blockFiscal}
                                    setData={this.setOrdersFilters('statuses')}
                                    values={this.props.filters.statuses}
                                    notAll={true}
                                />
                            </div>
                        </td>     
                        <td className='kt-datatable__cell order_table action'></td>
                    </tr>
                    <tr className='kt-datatable__row'>
                        <td className='kt-indicator' style={{ backgroundColor: '#00000000' }} />
                        <td className='kt-datatable__cell order_table positions'>
                            <Select
                                isLoading={this.props.loading}
                                isDisabled={this.props.loading || this.props.blockFiscal}
                                placeholder='Источник'
                                value={this.props.filters.source}
                                onChange={this.setOrdersFilters('source')}
                                isClearable={true}
                                options={[
                                    { label: 'Без источника', value: 'none' },
                                    ...this.state.platforms,
                                ]}
                            />
                        </td>
                        <td className='kt-datatable__cell order_table total_price' />
                        <td className='kt-datatable__cell order_table total_price' />
                        <td className='kt-datatable__cell order_table payment' />
                        <td className='kt-datatable__cell order_table point_time' />
                        <td className={`kt-datatable__cell order_table select_point${(window.innerWidth > 1024 && this.state.openClient) ? ' openClient' : ''}`} />
                        <td className='kt-datatable__cell order_table comment' />
                        <td className='kt-datatable__cell order_table phone' />   
                        <td className='kt-datatable__cell order_table action'/>
                    </tr>
                </table>
            );        
    }

    render() {
        if (this.props.loading) {
            return (
                <div style={styles.loading}><Loader /> </div>
            );
        }
        
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="kt-portlet__body">
                        <div className="kt-form kt-form--label-right kt-margin-b-10">
                            {window.innerWidth <= 1024 &&
                                <div style={{ position: 'fixed', top: '8px', right: '60px', zIndex: '10000', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <button disabled={this.props.blockFiscal} onClick={this.onOpenModalSearch} className='head_mobile_btn'><i className="la la-search"></i></button>
                                    {(this.props.filters.phone || this.props.filters.id) && <button
                                        disabled={this.props.blockFiscal}
                                        onClick={this.clearSearchFilter}
                                        className='head_mobile_btn'
                                        style={{ color: '#ffb822' }}
                                        title={this.props.filters.phone ? `Поиск по тел: ${this.props.filters.phone}` : `Поиск по заказу: ${this.props.filters.id}`}
                                    ><i className="la la-times"></i></button>}
                                    <button disabled={this.props.blockFiscal} onClick={this.onRefresh} className='head_mobile_btn'><i className="la la-refresh"></i></button>
                                </div>
                            }
                            {this.renderFiltersBlock()}
                        </div>
                    </div>
                    <Portlet fit={true} style={{ backgroundColor: '#00000000', boxShadow: 'none' }}>
                        <ErrorContainer field="orders" style={{ margin: 15 }} hasCloseButton={true}/>
                        <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded" style={{ marginBottom: '0px'}}>
                            <OrdersTable platforms={this.state.platforms} isArchive={this.props.isArchive} onDelete={this.onDelete} items={this.props.orders} filials={this.props.filials}/>
                            {
                                this.props.orders.length > 0 && this.renderPagination()
                            }
                        </div>
                    </Portlet>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    statistics: state.statistics.ordersOfHead,
    orders: state.orders.list,
    blockFiscal: state.orders.blockFiscal,
    filters: state.orders.filters,
    loading: state.loaders.orders || state.loaders.sources || state.loaders.settings || state.loaders.ordersOfHead || state.loaders.filials || state.loaders.cities,
    count: state.orders.count,
    paging: state.orders.paging,
    cities: state.handbook.cities,
    filials: state.handbook.filials,
    role: state.user.info.role.id,
    settings: state.settings.init.categories,
    goods: state.good.list,
    UImobile: state.UImobile,
    payments: state.handbook.payments,
    userPoints: state.user.info.points,
    couriers: state.users.couriers,
    loadingCourier: state.loaders.couriers,
    sseEnabled: state.notifications.sseEnabled,
    autoRefreshEnabled: state.notifications.autoRefreshEnabled,
    autoRefreshInterval: state.notifications.autoRefreshInterval,
    sources: state.handbook.sources,
});

const mapDispatchToProps = {
    fetchOrders: (isArchive, getCouriers) => fetchOrders({}, isArchive, getCouriers),
    setOrdersPaging: (paging) => setOrdersPaging(paging),
    deleteOrder: (id, isArchive) => deleteOrder(id, isArchive),
    fetchCities: () => fetchCities(true),
    fetchFilials: (city) => fetchFilials(city, true),
    setOrdersFilters: (filters) => setOrdersFilters(filters),
    fetchSettings: () => fetchSettings(),
    fetchZonesByCities: () => fetchZonesByCities(),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
    setActiveModalAction: (value) => setActiveModalAction(value),
    fetchPayments: (isGetAll) => fetchPayments(isGetAll),
    getStatusKKT: (pointId) => getStatusKKT(pointId),
    silentFetchOrders: (isArchive, getCouriers) => silentFetchOrders({}, isArchive, getCouriers),
    initializeNotifications,
    disconnectNotifications,
    updateNotificationPreferences: (prefs) => updateNotificationPreferences(prefs),
    handleConsumption: (isArchive) => handleConsumption(isArchive),
    fetchSources: (isGetAll, withoutCount, returnSources) => fetchSources(isGetAll, withoutCount, returnSources),
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrdersList));